export const QUIZ_STEPS = [
  {
    id: 'q1',
    type: 'question',
    question: "What result are you looking to achieve right now?",
    options: [
      "Reduce stress and regain energy",
      "Gain clarity and focus",
      "Overcome mental blocks",
      "Grow my business and income",
      "Scale to the next level"
    ]
  },
  {
    id: 'q2',
    type: 'question',
    question: "What is your biggest challenge right now?",
    options: [
      "Burnout / low energy",
      "Overthinking / lack of clarity",
      "Fear or self-doubt",
      "Inconsistent income or clients",
      "Feeling stuck / not progressing"
    ]
  },
  {
    id: 'q3',
    type: 'question',
    question: "What have you already tried to solve this?",
    options: [
      "Coaching or therapy",
      "Courses or programs",
      "Self-learning (books, YouTube, etc.)",
      "Tried multiple things without success",
      "Haven’t tried much yet"
    ]
  },
  {
    id: 'contact',
    type: 'contact',
    title: "Where should we send your personalized result?",
    subtext: "Based on your answers so far, we're preparing a tailored recommendation for you. Enter your details below to receive your result and next steps."
  },
  {
    id: 'q4',
    type: 'question',
    question: "What budget have you allocated to solve this?",
    options: [
      "Below $2,500",
      "$2,500 – $5,000",
      "$5,000 – $7,500",
      "$7,500+"
    ]
  },
  {
    id: 'q5',
    type: 'question',
    question: "Are you the decision-maker?",
    options: [
      "Yes",
      "No",
      "I need approval"
    ]
  },
  {
    id: 'q6',
    type: 'question',
    question: "If nothing changes, what will this cost you in the next 3–6 months?",
    options: [
      "Increased stress and burnout",
      "Lost income or missed opportunities",
      "Stagnation in career/business",
      "Significant personal and financial impact"
    ]
  },
  {
    id: 'q7',
    type: 'question',
    question: "When do you want to implement a solution?",
    options: [
      "Immediately",
      "Within 1 month",
      "Within 1–3 months",
      "3–6 months",
      "Not sure"
    ]
  },
  {
    id: 'q8',
    type: 'question',
    question: "On a scale of 1–10, how ready are you to take action?",
    options: [
      "1–3",
      "4–6",
      "7–8",
      "9–10"
    ]
  }
];

export const calculateQualification = (answers) => {
  let score = 0;
  let isDisqualified = false;

  // Budget
  if (["$2,500 – $5,000", "$5,000 – $7,500", "$7,500+"].includes(answers.q4)) score += 1;
  if (answers.q4 === "Below $2,500") isDisqualified = true;

  // Decision Maker
  if (answers.q5 === "Yes") score += 1;

  // Timeline
  if (["Immediately", "Within 1 month", "Within 1–3 months"].includes(answers.q7)) score += 1;
  if (["3–6 months", "Not sure"].includes(answers.q7)) isDisqualified = true;

  // Readiness
  if (["7–8", "9–10"].includes(answers.q8)) score += 1;

  // Problem matches MaDa Framework (Assumed true if they completed Q1 & Q2)
  if (answers.q1 && answers.q2) score += 1;

  return {
    isQualified: score >= 3 && !isDisqualified,
    score
  };
};